'use client';
import { TKeyValuePair } from '@/types';
import * as Styled from './styled';
import useDataframeContext from '../../../DataframeContext';
import isEqual from 'lodash-es/isEqual';
import Button from '@/ui/Button';
import { Row } from '@/ui/primatives';

import { TrashIcon, CounterClockwiseClockIcon as UndoIcon } from '@radix-ui/react-icons';
import * as Icon from '@/ui/Icon';
import { SYSTEM_ROW_ID_FIELD_NAME, DIFF_STATUS_FIELD_NAME } from '@/components/DataFrame/consts';

const DiffStatus: React.FC<{ status: string }> = ({ status }) => {
  if (status === 'added') {
    return <Styled.AddedRow>Added</Styled.AddedRow>;
  }
  if (status === 'removed') {
    return <Styled.RemovedRow>Removed</Styled.RemovedRow>;
  }
  if (status === 'modified') {
    return <Styled.ModifiedRow>Modified</Styled.ModifiedRow>;
  }
  return <div />;
};

const RowActions: React.FC<{
  row: TKeyValuePair;
  workingRow: TKeyValuePair;
  commitChanges: (x: TKeyValuePair) => void;
}> = ({ row, workingRow, commitChanges }) => {
  const { deleteRow, editable, restoreDfRow } = useDataframeContext();
  const diffStatus = row?.[DIFF_STATUS_FIELD_NAME];
  const isDirty = !isEqual(row, workingRow);
  return (
    editable && (
      <Styled.RowActions>
        <DiffStatus status={diffStatus} />
        <Row gap={5} alignItems="center">
          {isDirty && (
            <Button.Black
              small
              style={{ padding: '3px 7px', borderRadius: 3, alignItems: 'center' }}
              onClick={commitChanges}
            >
              <Icon.Save size="12" />
              Save
            </Button.Black>
          )}
          {diffStatus !== 'unchanged' && (
            <Styled.RevertRowChanges onClick={() => restoreDfRow(row[SYSTEM_ROW_ID_FIELD_NAME])}>
              <UndoIcon />
              <span>Revert</span>
            </Styled.RevertRowChanges>
          )}
          {diffStatus !== 'removed' && (
            <Styled.DeleteRow onClick={() => deleteRow(row[SYSTEM_ROW_ID_FIELD_NAME])}>
              <TrashIcon />
              <span>Delete</span>
            </Styled.DeleteRow>
          )}
        </Row>
      </Styled.RowActions>
    )
  );
};

export default RowActions;
